import type { HttpClient } from '~/shared/api'
import { ApiService, toModel } from '~/shared/api'
import type { Logger } from '~/shared/interfaces'
import { ResearchShowcaseDetail } from '~/models/research-showcase'
import { API_PREFIX } from '~/shared/const/request-services'

export class ResearchShowcaseDetailService extends ApiService {
  constructor(
    http: HttpClient,
    private readonly logger: Logger,
  ) {
    super(http)
  }

  readonly urls = {
    bySlug: (slug: string) => `${API_PREFIX}/research-showcase-cards/${slug}`,
    like: (slug: string) => `${API_PREFIX}/research-showcase-cards/${slug}/add-like`,
    view: (slug: string) => `${API_PREFIX}/research-showcase-cards/${slug}/add-view`,
  }

  getBySlug(slug: string): Promise<ResearchShowcaseDetail> {
    return this.http.request({ url: this.urls.bySlug(slug) }).then(toModel(ResearchShowcaseDetail))
  }

  async addLike(slug: string): Promise<boolean> {
    try {
      await this.http.request({ method: 'POST', url: this.urls.like(slug) })
      return true
    }
    catch (error) {
      this.logger.warn(`Failed to like "${slug}"`, error)
      return false
    }
  }

  async addView(slug: string): Promise<boolean> {
    try {
      await this.http.request({ method: 'POST', url: this.urls.view(slug) })
      return true
    }
    catch (error) {
      this.logger.warn(`Failed to add view for "${slug}"`, error)
      return false
    }
  }
}
